//hide on scroll and show on scroll-up

var prevScrollpos = window.pageYOffset
window.onscroll = function() {
	var currentScrollPos = window.pageYOffset
	let $serviceMenu = $('.secondary-menu')
	if (prevScrollpos > currentScrollPos) {
		$serviceMenu.css('max-height', '1000px')
		$serviceMenu.css('opacity', '1')
	} else {
		$serviceMenu.css('max-height', '0')
		$serviceMenu.css('opacity', '0')
	}
	prevScrollpos = currentScrollPos
}

// sub-menu items hide and show on main menu click
$('.menu-item-has-children .nav-main-link').on('click', function(e) {
	e.preventDefault()
	const $me = $(this)
	const $parent = $me.parents('li')
	const $submenu = $(`#${$me.attr('data-sub-menu')}`)
	if ($parent.hasClass('active')) {
		$submenu.removeClass('open').hide()
		$me.parents('li')
			.toggleClass('active')
			.siblings()
			.removeClass('active')
		return false
	}
	$me.parents('li')
		.toggleClass('active')
		.siblings()
		.removeClass('active')
	$submenu
		.slideDown(10)
		.addClass('open')
		.siblings()
		.hide()
	$submenu.siblings().removeClass('open')
})

/** hide if click outside nav section */
window.addEventListener('click', function(e){   
	let submenuDiv = $('.sub-menu');
	let navItem = $('.nav-main-item');

	if(!$('#nav-main-wrap')[0]) {
		return false;
	}
	
	if (document.getElementById('nav-main-wrap').contains(e.target)){
	  return false;
	} else{
	  if(submenuDiv.hasClass('open')) {
		submenuDiv.removeClass('open');
		submenuDiv.hide();
		navItem.removeClass('active');
	  } else {
		  return false;
	  }
	}
});
